import controller from './most-selled-products.controller';
import template from './most-selled-products.view.html';

let MostSelledProductsComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default MostSelledProductsComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/most-selled-products/most-selled-products.component.js
 **/